export class OnOffSwitch extends HTMLElement
{
    constructor()
    {
        super();
    }

    connectedCallback()
    {
        this.render();
        this.init();
    }

    init()
    {
        this.initEventHandlers();
    }

    render()
    {
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.classList.add('on-off-switch-checkbox');
        input.name = 'on-off-switch';
        if (this.dataset.name !== undefined) {
            input.name = this.dataset.name;
        }
        input.setAttribute('tabindex', '0');
        this.appendChild(input);

        const label = document.createElement('label');
        label.classList.add('on-off-switch-label');
        this.appendChild(label);

        const span = document.createElement('span');
        span.classList.add('on-off-switch-inner');
        span.dataset.off_text = this.dataset.off_text || 'Off';
        span.dataset.on_text = this.dataset.on_text || 'On';
        if (this.dataset.initial_state === "on") {
            input.checked = true;
            span.style.backgroundColor = this.dataset.on_background_color || "#357ca5";
            span.style.color = this.dataset.on_text_color || "#ffffff";
        } else { 
            input.checked = false;
            span.style.backgroundColor = this.dataset.off_background_color || "#dcdcdc";
            span.style.color = this.dataset.off_text_color || "#ffffff";
        }
        label.appendChild(span);

        const span2 = document.createElement('span');
        span2.classList.add('on-off-switch-switch');
        label.appendChild(span2);

        this.input = input;
    }

        initEventHandlers()
    {
        this.addEventListener('click', this.onClick);
    }

    onClick()
    {
        this.input.checked = !this.input.checked;

        const span = this.querySelector('.on-off-switch-inner');
        if (this.input.checked) {
            span.style.backgroundColor = this.dataset.on_background_color || "#357ca5";
            span.style.color = this.dataset.on_text_color || "#ffffff";
        } else {
            span.style.backgroundColor = this.dataset.off_background_color || "#dcdcdc";
            span.style.color = this.dataset.off_text_color || "#ffffff";
        }

        // Dispatch the change event
        const customEvent = new CustomEvent('on-off-switch-changed-state', {
            detail: {
                state: this.input.checked ? 'on' : 'off'
            }
        });
        if (customEvent.detail.state == "on") {
            this.classList.add('on');
            this.classList.remove('off');
        } else {
            this.classList.add('off');
            this.classList.remove('on');
        }
        this.dispatchEvent(customEvent);

    }
}

customElements.define('on-off-switch', OnOffSwitch);
